import axios from 'axios';

/**
 * Whether an API error is an HTTP 413 (Payload Too Large) response, e.g. a target schema too large
 * to return.
 */
export function isPayloadTooLarge(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 413;
}
